import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from 'reactstrap';
import { faRedoAlt, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import { useEffect } from 'react';

const FileSearchBlock = ({ fileSearchCallback, className = '', _handleFileSearch, keyWord, _setKeyword }) => {



	const fileCloseHandler = () => {
		fileSearchCallback(false);
	}



	const restSearch = () => {
		_handleFileSearch('');
	}

	const __handleAutoSearch = (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")) {
			_setKeyword(val)
		} else {
			restSearch()
		}
	};

	/***
	 * @description function use for search trigger
	 * @param {refObj} event accepting element event 
	 */
	const onKeyDownEvent = (event) => {
		if (event.key === 'Enter') {
			if (event.target.value.trim() && event.target.value.trim().replace(/\./g, "")) {
				_setKeyword(event.target.value)
				_handleFileSearch(event.target.value);
			} else if (event.target.value === "") {
				restSearch()
			}
		}

	}


	return (
		<div className={`file-srch-blc position-relative ${className}`}>
			<Input type="text" value={keyWord} onChange={(e) => { if (e.target.value !== " ") { __handleAutoSearch(e.target.value) } }} placeholder='Search by name'
				onKeyDown={(e) => {
					if (e.key === '.') {
						e.stopPropagation();
						e.preventDefault();
					} else {
						onKeyDownEvent(e)
					}
				}} id="search" />
			<span color="link"
				className="position-absolute d-inline-flex align-items-center justify-content-center input-srch-icon">
				<FontAwesomeIcon icon={faSearch} />
			</span>
			<Button color="link"
				className="d-inline-flex align-items-center justify-content-center input-srch-btn-responsive" onClick={() => fileSearchCallback(true)}>
				<FontAwesomeIcon icon={faSearch} />
			</Button>
			<Button color="link"
				className="position-absolute d-inline-flex align-items-center justify-content-center input-clear-btn p-0" onClick={() => restSearch()}>
				<FontAwesomeIcon icon={faRedoAlt} />
			</Button>
			<Button color="link"
				className="position-absolute d-inline-flex align-items-center justify-content-center input-srch-close-responsive p-0" onClick={() => fileCloseHandler()}>
				<FontAwesomeIcon icon={faTimes} />
			</Button>
		</div>
	);
}

export default FileSearchBlock;